<sc-action-icon
    (click)="clickButton()"
    [disabled]="disabled" iconClass="fa-info">
</sc-action-icon>
